import { render, staticRenderFns } from "./custom-object-sidebar.vue?vue&type=template&id=fceeedf0&scoped=true&"
import script from "./custom-object-sidebar.js?vue&type=script&lang=js&"
export * from "./custom-object-sidebar.js?vue&type=script&lang=js&"
import style0 from "./custom-object-sidebar.scss?vue&type=style&index=0&id=fceeedf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceeedf0",
  null
  
)

component.options.__file = "custom-object-sidebar.vue"
export default component.exports